import script from "./TumorBoardPreviousSessions.vue?vue&type=script&setup=true&lang=js"
export * from "./TumorBoardPreviousSessions.vue?vue&type=script&setup=true&lang=js"

import "./TumorBoardPreviousSessions.vue?vue&type=style&index=0&id=5f23fda2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f23fda2"]])

export default __exports__